import { useTitle } from "@/hooks/use-title.hook.ts";
import EmployeesWithRoles from "@/pages/settings/roles/index/components/EmployeesWithRoles.tsx";
import RolesList from "@/pages/settings/roles/index/components/RolesList.tsx";
import { PageRolesProps } from "@/pages/settings/roles/role.types.ts";
import { ButtonLink, FontAwesomeIcon, Page, Stack, TabItem, Tabs } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function RolesV2({ tab = "list" }: PageRolesProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useTitle(t("core:roles"), t("common:settings"));

  const handleTabChanged = (tabIndex: number) => {
    const urls = ["/settings/roles-and-permissions", "/settings/roles-and-permissions/employees"];

    navigate(urls[tabIndex]);
  };

  const isEmployeesTab = tab !== "list";

  return (
    <Page className={isEmployeesTab ? "h-full" : undefined}>
      <Page.Header showBack={true} title={t("core:roles_and_permissions")} navigateTo={"/settings"}>
        <ButtonLink
          href={"/settings/roles-and-permissions/new"}
          leftIcon={<FontAwesomeIcon icon="fa-light fa-plus" />}
        >
          {t("common:create_new")}
        </ButtonLink>
      </Page.Header>
      <Page.Content stretch={isEmployeesTab}>
        <Stack
          direction={"vertical"}
          className={isEmployeesTab ? "px-16 flex-1 min-h-0 min-w-0" : "px-16"}
        >
          <Tabs
            fill={isEmployeesTab}
            onActiveTabChange={handleTabChanged}
            activeTab={tab == "list" ? 0 : 1}
          >
            <TabItem title={t("core:roles")}>
              <RolesList />
            </TabItem>
            <TabItem
              title={t("core:employees")}
              className={isEmployeesTab ? "flex min-h-0 min-w-0 flex-1 flex-col" : undefined}
            >
              <EmployeesWithRoles />
            </TabItem>
          </Tabs>
        </Stack>
      </Page.Content>
    </Page>
  );
}
